<div class="container-fluid" style="margin-bottom: 5px; margin-top: 10px">
  <div class="row">
    <div class="col-2">
      <button type="button" style="font-size: 18px" class="btn btn-labeled btn-success" (click)="changeScreenToInputProduct()">
        <span class="btn-label"><i class="fas fa-plus-circle"></i></span> Adăugare Produs
      </button>
    </div>
    <div class="col-4"></div>
    <div class="col-4">
      <input type="text" ngModel="{{currentProductSearchWord}}" class="form-control" style="font-family: FontAwesome;"  title="Căutare" id="searchBar" placeholder="&#xF002;" (ngModelChange)="refreshAfterSearch(searchWord.value)" #searchWord>
    </div>
    <div class="col-2"></div>
  </div>
</div>

<div class="container-fluid table-responsive" style="padding: 1%">
  <table class="table">
    <thead>
    <tr>
      <th scope="col" style="width: 12%">
        <div>
          Vendor
          <button class="btn btn-default" (click)="changeSortOnVendor()"><i class="bi bi-sort-alpha-down"></i></button>
          <i *ngIf="currentProductSortColumn == 'VENDOR' && currentProductSortDesc" class="bi bi-arrow-down"></i>
          <i *ngIf="currentProductSortColumn == 'VENDOR' && !currentProductSortDesc" class="bi bi-arrow-up"></i>
        </div>
      </th>
      <th scope="col" style="width: 14%">
        <div>
          Part Number
          <button class="btn btn-default" (click)="changeSortOnPartNo()"><i class="bi bi-sort-alpha-down"></i></button>
          <i *ngIf="currentProductSortColumn == 'PARTNO' && currentProductSortDesc" class="bi bi-arrow-down"></i>
          <i *ngIf="currentProductSortColumn == 'PARTNO' && !currentProductSortDesc" class="bi bi-arrow-up"></i>
        </div>
      </th>
      <th scope="col" style="width: 10%" *ngIf="!isMobile">
        <div>
          HS Code
          <button class="btn btn-default" (click)="changeSortOnHsCode()"><i class="bi bi-sort-alpha-down"></i></button>
          <i *ngIf="currentProductSortColumn == 'HSCODE' && currentProductSortDesc" class="bi bi-arrow-down"></i>
          <i *ngIf="currentProductSortColumn == 'HSCODE' && !currentProductSortDesc" class="bi bi-arrow-up"></i>
        </div>
      </th>
      <th scope="col" style="width: 10%" *ngIf="!isMobile">
        <div>
          ECCN
          <button class="btn btn-default" (click)="changeSortOnEccn()"><i class="bi bi-sort-alpha-down"></i></button>
          <i *ngIf="currentProductSortColumn == 'ECCN' && currentProductSortDesc" class="bi bi-arrow-down"></i>
          <i *ngIf="currentProductSortColumn == 'ECCN' && !currentProductSortDesc" class="bi bi-arrow-up"></i>
        </div>
      </th>
      <th scope="col" style="width: 25%" *ngIf="!isMobile">
        <div>
          Timbru Verde
          <button class="btn btn-default" (click)="changeSortOnCategorieTimbruVerde()"><i class="bi bi-sort-alpha-down"></i></button>
          <i *ngIf="currentProductSortColumn == 'CATEGORIETIMBRUVERDE' && currentProductSortDesc" class="bi bi-arrow-down"></i>
          <i *ngIf="currentProductSortColumn == 'CATEGORIETIMBRUVERDE' && !currentProductSortDesc" class="bi bi-arrow-up"></i>
        </div>
      </th>
      <th scope="col" style="width: 16%" *ngIf="!isMobile">
        <div>
          Țară de Origine
          <button class="btn btn-default" (click)="changeSortOnTaraOrigine()"><i class="bi bi-sort-alpha-down"></i></button>
          <i *ngIf="currentProductSortColumn == 'TARAORIGINE' && currentProductSortDesc" class="bi bi-arrow-down"></i>
          <i *ngIf="currentProductSortColumn == 'TARAORIGINE' && !currentProductSortDesc" class="bi bi-arrow-up"></i>
        </div>
      </th>
      <th scope="col" style="width: 12%"></th>
    </tr>
    </thead>
    <tbody *ngFor="let product of products">
      <tr>
        <td style="white-space: nowrap; text-overflow:ellipsis; overflow: hidden; max-width:1px;" [ngClass]="smallFont(isMobile)">{{product.Vendor}}</td>
        <td style="white-space: nowrap; text-overflow:ellipsis; overflow: hidden; max-width:1px;" [ngClass]="smallFont(isMobile)">{{product.PartNo}}</td>
        <td style="white-space: nowrap; text-overflow:ellipsis; overflow: hidden; max-width:1px;" *ngIf="!isMobile">{{product.HsCode}}</td>
        <td style="white-space: nowrap; text-overflow:ellipsis; overflow: hidden; max-width:1px;" *ngIf="!isMobile">{{product.Eccn}}</td>
        <td style="white-space: nowrap; text-overflow:ellipsis; overflow: hidden; max-width:1px;" *ngIf="!isMobile">{{product.CategorieTimbruVerde}}</td>
        <td style="white-space: nowrap; text-overflow:ellipsis; overflow: hidden; max-width:1px;" *ngIf="!isMobile">{{product.TaraOrigine}}</td>
        <td>
          <button type="button" class="btn btn-secondary" style="margin: 1%" title="Modificare" (click)="editProduct(product)"><i class="far fa-edit"></i></button>
          <button type="button" class="btn btn-danger" style="margin: 1%" title="Ștergere" (click)="deleteProduct(product)"><i class="bi bi-trash"></i></button>
        </td>
      </tr>
  </table>

  <div *ngIf="numberOfProductPages > 1" class="container">
    <div class="container-fluid col-12">
      <div class="row">
        <button class="btn btn-info" style="margin: 2px" type="button" (click)="goToFirstPage()"><i class="bi bi-chevron-double-left"></i></button>
        <button class="btn btn-info" style="margin: 2px" type="button" (click)="goToPrevPage()"><i class="bi bi-chevron-left"></i></button>
        <div style="margin: 4px; font-size: 19px">{{currentProductPage}} / {{numberOfProductPages}}</div>
        <button class="btn btn-info" style="margin: 2px" type="button" (click)="goToNextPage()"><i class="bi bi-chevron-right"></i></button>
        <button class="btn btn-info" style="margin: 2px" type="button" (click)="goToLastPage()"><i class="bi bi-chevron-double-right"></i></button>
      </div>
    </div>
  </div>

</div>
